import { globalFetch } from './globalActions';
import { TECH_MESSAGE_SUCCESS, TECH_MESSAGE_IS_LOADING, TECH_MESSAGE_HAS_ERRORED } from './types';
import { PROM_CAT_TECHALERT_ID } from '../constants';

///////////
// Tech Message Feed //
///////////

export function fetchTechMessage(lang) {
	const id = PROM_CAT_TECHALERT_ID;
	return globalFetch({
		urlPath: `cards`,
		extraParams: `&section=${id}&format=json`,
		urlSrc: 2,
		reducerIsLoading: TECH_MESSAGE_IS_LOADING,
		reducerError: TECH_MESSAGE_HAS_ERRORED,
		dispatchSuccess: (itemObj, dispatch) => {
			dispatch(fetchTechMessageSuccess(itemObj));
		}
	});
}

export function fetchTechMessageSuccess(items) {
	const res = items.results[0];
	let message = {};

	if (res && Object.keys(res).length > 0) {
		message = {
			"error": true, "message": {
				copy: res.content,
				linkLabel: res.subheading,
				linkURL: res.entered_url,
				title: res.title
			}
		};
	}

	return {
		type: TECH_MESSAGE_SUCCESS,
		payload: message
	};
}
